import {
  CHANGE_CONVERSATION_STATUS,
  CREATE_CONVERSATION,
  GET_CONVERSATIONS_FAILURE,
  GET_CONVERSATIONS_REQUEST,
  GET_CONVERSATIONS_SUCCESS,
  GET_MESSAGES_BY_CONVERSATIONID,
  REPLY_MESSAGE,
  UPDATE_MEMBER_MESSAGE_REQUEST,
  GET_MESSAGES_BY_CRM_CASE_ID,
  SET_REPLY_FORM_VALIDATION_STATUSES,
  SET_LOADING,
  RESET_ERROR_STATES
} from '../constants'
import uuid from 'uuid/v4'
import { api } from '../services'
import { MESSAGE_TYPE_KEYS, MESSAGE_CRM_CASE_ID_API_FAILED } from 'constants/constant.message'

const createConversationAction = (message) => async (dispatch) => {
    dispatch({ type: CREATE_CONVERSATION.START });
    try {
        message = await uploadFilesToS3(message);
        const result = await api.createConversation(message);

        dispatch({ type: CREATE_CONVERSATION.SUCCEED, payload: result.data });
        dispatch(getConversationsByRecipientIdAction(message.recipientId, null, 'inbox'));
    } catch (error) {
        //TODO if 2 users are trying to send the message  together it might fail in that case get the conversationVersion with getMessagesByConversationId(converationId) and update it
        dispatch({ type: CREATE_CONVERSATION.FAIL, payload: error.message });
    }
}

const changeConversationStatusAction = (conversation, messageTab) => async (dispatch, getState) => {
    dispatch({ type: CHANGE_CONVERSATION_STATUS.START });
    try {
        if (conversation.type === 'legacy') {
            let params = { memberUuid: conversation.recipientId, messageId: conversation.lastMessage.messageId, replyRequired: true, completed: false };

            if (messageTab === 'inbox') {
                params.replyRequired = false;
                params.completed = true;
            }
            // else if (filter === 'complete') {
            // }
            dispatch({ type: UPDATE_MEMBER_MESSAGE_REQUEST, payload: params })
            dispatch({ type: CHANGE_CONVERSATION_STATUS.SUCCEED, payload: conversation.conversationId });
        } else {
            conversation = { conversationId: conversation.conversationId, recipientId: conversation.recipientId, status: conversation.status }
            const result = await api.changeConversationStatus(conversation);
            dispatch({ type: CHANGE_CONVERSATION_STATUS.SUCCEED, payload: result.data.Attributes.conversationId });
        }
        // dispatch({ type: CHANGE_CONVERSATION_STATUS.SUCCEED, payload: converstaion.conversationId }); //for testing
    } catch (e) {
        dispatch({ type: CHANGE_CONVERSATION_STATUS.FAIL, paylaod: e.message });
    }
}

const replyMessageByConversationIdAction = (message, messageTab, memberId) => async (dispatch, getState) => {
    dispatch({ type: REPLY_MESSAGE.START });
    try {
        message = await uploadFilesToS3(message);
        let result;
        if (message.conversationId.includes('LOCAL_')) {
            let locallyCreatedConversation = getState().conversations.conversations.Items.find(conversation => conversation.conversationId === message.conversationId);
            locallyCreatedConversation.repliedMessage = message;
            result = await api.createConversationAndReplyToMessage(locallyCreatedConversation);
            dispatch({ type: REPLY_MESSAGE.SUCCEED, payload: { ...message, senderFullName: sessionStorage.getItem('csr_user_email') } });
            if (memberId) {
                dispatch(getConversationsByRecipientIdAction(locallyCreatedConversation.recipientId, null, messageTab));
            } else {
                dispatch(getConversationsByStatusAction('CSR_ACTION_REQUIRED', null, messageTab));
            }

        } else {
            //  delete message.topic;
            result = await api.replyMessageByConversationId(message);
            dispatch({ type: REPLY_MESSAGE.SUCCEED, payload: { ...message, senderFullName: sessionStorage.getItem('csr_user_email') } });
        }

        return result;
    } catch (error) {
        console.log(error)
        //TODO if 2 users are trying to send the message  together it might fail in that case get the conversationVersion with getMessagesByConversationId(converationId) and update it
        dispatch({ type: REPLY_MESSAGE.FAIL, payload: error.message });
    }

};

const getConversationsByRecipientIdAction = (recipientId, lastEvaluatedKey, messageTab, showUnrepliedMessagesFilter = false) => async (dispatch, getState) => {
    dispatch({ type: GET_CONVERSATIONS_REQUEST, payload: lastEvaluatedKey });
    try {
        const status = messageTab.toUpperCase(); // === 'inbox' ? 'INCOMPLETE' : 'COMPLETE';
        let tasks = [api.getConversationsByRecipientId(recipientId, lastEvaluatedKey, status)];

        if (!lastEvaluatedKey) {
            tasks.push(api.getMemberInboxMessages({ memberUuid: recipientId, messageFolder: messageTab }));
            if (status === 'COMPLETE') {
                tasks.push(api.getMessageInfo({ memberUuid: recipientId }))
            }
        }



        let results = await Promise.all(tasks);

        let conversations = results[0].data;

        //fetch all mesages
        while (conversations.LastEvaluatedKey) {
            let moreConversations = await api.getConversationsByRecipientId(recipientId, conversations.LastEvaluatedKey, status);
            conversations = { ...moreConversations.data, Items: [...conversations.Items, ...moreConversations.data.Items] }
        }

        if (lastEvaluatedKey) {
            conversations.Items = [...getState().conversations.conversations.Items, ...conversations.Items]
        }

        let legacyMessages = results[1] ? results[1].data.messages : []; //array of messages

        if (status === 'COMPLETE' && results[2]) {
            legacyMessages = [...legacyMessages, ...results[2].data]
        }

        const listOfConvertedConversations = legacyMessages.map(msg => {
          return {
              conversationId: `LOCAL_${msg.messageId}`,
              conversationVersion: 1,
              creator: msg.recipientId,
              recipientId: msg.recipientId,
              creatorFullName: msg.recipientFirstName + ' ' + msg.recipientLastName,
              topic: msg.subject || msg.msgSubject,
              transactionDate: msg.transactionDate,
              createdTimestamp: msg.transactionDate ? Date.parse(msg.transactionDate) : msg.createdTimestamp,
              type: 'legacy', //used in fetching the message
              status: msg.completed ? 'COMPLETE' : 'INBOX',
              lastMessage: {
                messageId: msg.messageId,
                senderFullName: msg.recipientFirstName + ' ' + msg.recipientLastName,
                senderId: msg.recipientId,
                message: msg.message || msg.msgText,
                attachments: msg.attachments,
                createdTimestamp: msg.transactionDate ? Date.parse(msg.transactionDate) : msg.createdTimestamp,
                typeKey: msg.typeKey ? msg.typeKey : null,
                'recipientType#notificationType#notificationEvent#notificationId': msg['recipientType#notificationType#notificationEvent#notificationId'],
              }
            };
        })
        conversations.Items = conversations.Items.concat(listOfConvertedConversations);
        //legacy messages ended

        if (showUnrepliedMessagesFilter) {
          conversations.Items = conversations.Items.filter(item => item.lastMessage?.typeKey && item.lastMessage?.typeKey === MESSAGE_TYPE_KEYS.MESSAGE)
        }

        conversations.fetchedAt = Date.now();
        dispatch({ type: GET_CONVERSATIONS_SUCCESS, payload: conversations });
    } catch (error) {
        dispatch({ type: GET_CONVERSATIONS_FAILURE, payload: error.message });
    }
}

const getConversationsByStatusAction = (status, lastEvaluatedKey, messageTab, showUnrepliedMessagesFilter = false) => async (dispatch, getState) => {
    dispatch({ type: GET_CONVERSATIONS_REQUEST, payload: lastEvaluatedKey });
    try {
        let tasks = [api.getConversationsByStatus(status, lastEvaluatedKey, 1000)];
        //load more doesn't apply to this
        if (!lastEvaluatedKey) {
            tasks.push(api.getMemberInboxMessages({ messageFolder: messageTab }))
        }
        let results = await Promise.all(tasks);
        // const results = await api.getConversationsByStatus(status, lastEvaluatedKey);
        let conversations = results[0].data;

        //fetch all messages
        while (conversations.LastEvaluatedKey) {
            let moreConversations = await api.getConversationsByStatus(status, conversations.LastEvaluatedKey, 1000);
            conversations = { ...moreConversations.data, Items: [...conversations.Items, ...moreConversations.data.Items] }
        }

        if (lastEvaluatedKey) {
            conversations.Items = [...getState().conversations.conversations.Items, ...conversations.Items]
        }

        const legacyMessages = results[1] ? results[1].data.messages : []; //array of messages
        const listOfConvertedConversations = legacyMessages.map(msg => {
          return {
              conversationId: `LOCAL_${msg.messageId}`,
              conversationVersion: 1,
              creator: msg.recipientId,
              recipientId: msg.recipientId,
              creatorFullName: msg.recipientFirstName + ' ' + msg.recipientLastName,
              topic: msg.subject,
              createdTimestamp: Date.parse(msg.transactionDate),
              type: 'legacy', //used in fetching the message
              lastMessage: {
                messageId: msg.messageId,
                senderFullName: msg.recipientFirstName + ' ' + msg.recipientLastName,
                senderId: msg.recipientId,
                message: msg.message,
                attachments: msg.attachments,
                createdTimestamp: Date.parse(msg.transactionDate),
                'recipientType#notificationType#notificationEvent#notificationId': msg['recipientType#notificationType#notificationEvent#notificationId']

              },
              member: {
                phoneNumber: msg.primaryPhone,
                emailAddress: msg.email,
                firstName: msg.recipientFirstName,
                lastName: msg.recipientLastName,
                familyId: msg.recipientFamilyId

              }
            };
        })
        conversations.Items = conversations.Items.concat(listOfConvertedConversations);

        if (showUnrepliedMessagesFilter) {
          conversations.Items = conversations.Items.filter(item => item.lastMessage?.typeKey && item.lastMessage?.typeKey === MESSAGE_TYPE_KEYS.MESSAGE)
        }

        dispatch({ type: GET_CONVERSATIONS_SUCCESS, payload: conversations });
    } catch (error) {
        dispatch({ type: GET_CONVERSATIONS_FAILURE, payload: error.message });
    }
}

const getMessagesByConversationIdAction = (conversation, lastEvaluatedKey) => async (dispatch, getState) => {
    //legacy message handler
    if (conversation.conversationId?.includes('LOCAL_')) {
        dispatch({ type: GET_MESSAGES_BY_CONVERSATIONID.SUCCEED, payload: { Items: [conversation.lastMessage], fetchedAt: Date.now(), conversationId: conversation.conversationId } });
    } else {
        dispatch({ type: GET_MESSAGES_BY_CONVERSATIONID.START, payload: lastEvaluatedKey });
        try {
            const results = await api.getMessagesByConversationId(conversation.conversationId, lastEvaluatedKey);
            let messages = results.data;
            if (lastEvaluatedKey) {
                messages.Items = [...getState().conversations?.messages?.Items, ...messages.Items]
            }
            messages.Items.sort((a, b) => b.createdTimestamp - a.createdTimestamp);
            messages.conversationId = conversation.conversationId;
            messages.fetchedAt = Date.now();
            dispatch({ type: GET_MESSAGES_BY_CONVERSATIONID.SUCCEED, payload: messages });
        } catch (error) {
            dispatch({ type: GET_MESSAGES_BY_CONVERSATIONID.FAIL, payload: error.message });
        }
    }

}

const uploadFilesToS3 = async (message) => {
    let attachments = [];
    if (message.files) {
        for (let i = 0; i < message.files.length; i++) {
            let params = {
                Key: `contact-us/attachments/${message.recipientId}/${uuid()}/${message.files[i].name}`,
                operation: 'putObject',
            };
            const getUploadUrlresponse = await api.getPreSignedUrl(params);
            let s3UploadUrl = getUploadUrlresponse.data.url;
            const s3UploadResponse = await api.putObjectInS3WithPreSignedUrl(s3UploadUrl, message.files[i]);
            if (s3UploadResponse.status === 200) {
                attachments.push({
                    Key: params.Key,
                    name: message.files[i].name,
                    size: message.files[i].size,
                    type: message.files[i].type,
                });
            }
        }
        delete message.files;
    }
    message.attachments = attachments;
    return message;
}

const searchMessagesByCrmCaseIdAction = (crmCaseId, status, recipientId = null, showUnrepliedMessagesFilter = false, isApiFailedConversationsOnly = false) => async (dispatch, getState) => {
  dispatch({
    type: GET_MESSAGES_BY_CRM_CASE_ID.START
  })

  try {
    const results = await api.getMessagesByCrmCaseId(crmCaseId, recipientId)

    if (isApiFailedConversationsOnly) {
      const apiFailedResults = await api.getMessagesByCrmCaseId(MESSAGE_CRM_CASE_ID_API_FAILED, recipientId)

      const crmConversationIds = results.data.Items.map((item) => item.conversationId);
      const apiFailedConversationIds = apiFailedResults.data.Items.map((item) => item.conversationId);
      // conversations that have API Failed messages AND specific CRM Case ID
      const conversationIdsSet = new Set([...crmConversationIds, apiFailedConversationIds]);

      results.data.Items = results.data.Items.filter((item) => conversationIdsSet.has(item.conversationId))
    }

    const messages = { Items: results.data.Items }

    if (recipientId) {
      messages.Items = results.data.Items.filter(item => item.recipientId === recipientId)
    }

    const uniqueConversationKeyPairs = []

    messages.Items.forEach(item => {
      const notProcessed = !uniqueConversationKeyPairs.find(subItem => item.recipientId === subItem.recipientId && item.conversationId === subItem.conversationId)
      if (notProcessed) {
        uniqueConversationKeyPairs.push({ recipientId: item.recipientId, conversationId: item.conversationId })
      }
    })

    const filteredConversationsByCrmCaseId = { Items: [], fetchedAt: new Date().toISOString() }

    const conversationPromises = uniqueConversationKeyPairs.map(({ recipientId, conversationId }) =>
      api.getConversationByConversationId(recipientId, conversationId)
    )
    
    const responses = await Promise.all(conversationPromises)
    
    responses.forEach((res) => {
      const resFilteredByStatus = res.data.Items.filter(item => item.status === status)
      filteredConversationsByCrmCaseId.Items.push(...resFilteredByStatus)
    })

    if (showUnrepliedMessagesFilter) {
      filteredConversationsByCrmCaseId.Items = filteredConversationsByCrmCaseId.Items.filter(item => item.lastMessage?.typeKey && item.lastMessage?.typeKey === MESSAGE_TYPE_KEYS.MESSAGE)
    }

    dispatch({ type: GET_MESSAGES_BY_CRM_CASE_ID.SUCCEED, payload: { filteredConversationsByCrmCaseId } })
  } catch (error) {
    dispatch({ type: GET_MESSAGES_BY_CRM_CASE_ID.FAIL, payload: error.message })
  }
}

const validateReplyFormCrmCaseIdAction = (crmCaseId, isSendingReply) => async (dispatch, getState) => {
  const validation = {
    isCaseNumberNotCreated: false,
    isCaseNumberNotInCurrentConversation: false,
    areCrmApisOffline: false
  }

  if (isSendingReply) {
    dispatch({ type: SET_LOADING, payload: { loading: true } })

    try {
      const res = await api.getCrmCaseState(crmCaseId)
      validation.isCaseNumberNotCreated = !res.data.isCreated
    } catch (e) {
      validation.areCrmApisOffline = true
    }
  }

  const currentMessages = [...getState().conversations?.messages?.Items]

  validation.isCaseNumberNotInCurrentConversation = !currentMessages.find(item => item.crmCaseId === crmCaseId)

  dispatch({ type: SET_REPLY_FORM_VALIDATION_STATUSES, payload: validation })

  if (isSendingReply) {
    // Add a small delay to ensure refs are updated from the useEffect hooks
    await new Promise(resolve => setTimeout(resolve, 1000))
    dispatch({ type: SET_LOADING, payload: { loading: false } })
  }
}

const resetReplyFormValidationStatuses = () => async (dispatch, getState) => {
  dispatch({
    type: SET_REPLY_FORM_VALIDATION_STATUSES,
    payload: {
      isCaseNumberNotCreated: false,
      isCaseNumberNotInCurrentConversation: false,
      areCrmApisOffline: false
    }
  })
}

const resetErrorStates = () => async (dispatch, getState) => {
  dispatch({
    type: RESET_ERROR_STATES,
    payload: {
      sendingMessageError: false,
      error: false
    }
  })
}

const actions = ({
  getConversationsByRecipientIdAction,
  getMessagesByConversationIdAction,
  replyMessageByConversationIdAction,
  createConversationAction,
  getConversationsByStatusAction,
  changeConversationStatusAction,
  searchMessagesByCrmCaseIdAction,
  validateReplyFormCrmCaseIdAction,
  resetReplyFormValidationStatuses,
  resetErrorStates
});

export default actions
